export class CustomField {
    id: number | null = null;
    type: CustomFieldEnum | null = null;
    label: string | null = null;
    minimum: number | null = null;
    maximum: number | null = null;
    field: string | null = null;
    helpText: string | null = null;
    mandatory: boolean | null = null;
    visibility: string[] | null = [];
    index: number | null = null;
}

export class CustomFieldDto {
    id: number = 0;
    type: CustomFieldEnum = CustomFieldEnum.SingleText;
    label: string = '';
    helpText?: string | null = null;
    mandatory: boolean = false;
    visibility: string[] | null = [];

    minimum?: number | null = null;
    maximum?: number | null = null;
    index: number | null = null;

    selectAll?: boolean = false;
    options?: string[] = [];
    multiSelect?: boolean = false;
    yesText?: string | null = null;
    noText?: string | null = null;

    value: string = '';
}

export class CustomFieldBase {
    minimum: number | null = null;
    maximum: number | null = null;
}

export interface CustomFieldText extends CustomFieldBase {
    value: string;
}

export interface CustomFieldNumber extends CustomFieldBase {
    value: number;
}

export class CustomFieldCheckbox extends CustomFieldBase {
    selectAll: boolean = false;
    options: string[] = [];
}

export interface CustomFieldDropdown extends CustomFieldBase {
    multiSelect: boolean;
    options: string[];
}

export interface CustomFieldRange extends CustomFieldBase {
    value: string;
}

export interface CustomFieldBoolean {
    yesText: string;
    noText: string;
    value: string;
}

export enum CustomFieldEnum {
    SingleText = 1,
    LongText = 2,
    Dropdown = 3,
    Checkbox = 4,
    Number = 5,
    Range = 6,
    YesNo = 7
}

export class CustomFieldDefaultRule implements ICustomFieldRule {
    showMin: boolean = true;
    showMax: boolean = true;
    requiredMin: boolean = false;
    requiredMax: boolean = false;
    showSelectAll: boolean = false;
    showMultiSelect: boolean = false;
    showYesNo: boolean = false;
    showOptions: boolean = false;
}

export class CustomFieldCheckboxRule extends CustomFieldDefaultRule {
    //showSelectAll: boolean = true;
    showOptions: boolean = true;
}

export class CustomFieldDropdownRule extends CustomFieldDefaultRule {
    showMultiSelect: boolean = true;
    showOptions: boolean = true;
}

export class CustomFieldYesNoRule extends CustomFieldDefaultRule {
    showYesNo: boolean = true;
}

export interface ICustomFieldRule {
    showMin: boolean;
    showMax: boolean;
    requiredMin: boolean;
    requiredMax: boolean;
    showSelectAll: boolean;
    showMultiSelect: boolean;
    showYesNo: boolean;
    showOptions: boolean;
}

export class CheckOutCustomField {
    id: number = 0;
    type: CustomFieldEnum = CustomFieldEnum.SingleText;
    label: string = '';
    value: string = '';
}